/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-04-04 14:36:00 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-04-04 17:05:40
 */

import * as React from "react";

import "./styles.scss";

export default class AwaitableBtn extends React.Component {
    
    constructor(props, context) {
        super(props, context);

        this.state = { waiting: false };
        
        this.onClick = this.onClick.bind(this);
    }

    async onClick(e) {
        this.setState({ waiting: true });
        try {
            await this.props.children.props.onClick(e);
        }
        finally {
            this.setState({ waiting: false });
        }
    }

    render() {
        const { onClick, disabled, className } = this.props.children.props;
        return (
            <React.Fragment>
                {
                    React.cloneElement(this.props.children, {
                        onClick: this.onClick,
                        disabled: this.state.waiting || disabled,
                        className: className || "" + ` awaitable-btn ${this.state.waiting ? " wait" : ""}`
                    })
                }
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/Base/AwaitableBtn/index.jsx